import { render, staticRenderFns } from "./XingWeiView.vue?vue&type=template&id=9f6a96aa&scoped=true"
import script from "./XingWeiView.vue?vue&type=script&lang=js"
export * from "./XingWeiView.vue?vue&type=script&lang=js"
import style0 from "./XingWeiView.vue?vue&type=style&index=0&id=9f6a96aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6a96aa",
  null
  
)

export default component.exports